/* MIT License
 *
 * Copyright (c) 2023 Mike Chambers
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import React from "react";

import { humanDuration } from "../core/utils/date";

const rootStyleBase = {
    padding: "4px 12px",
    fontWeight: "var(--regular)",
    borderRadius: "var(--radius-border)",
};

const DurationView = (props) => {
    const duration = props.duration;
    const backgroundColor = !!props.backgroundColor
        ? props.backgroundColor
        : "var(--color-text-container-background)";

    let rootStyle = {
        ...rootStyleBase,
        background: backgroundColor,
    };

    const d = humanDuration(duration);

    return (
        <div className="section_entry" style={rootStyle}>
            {d}
        </div>
    );
};

export default DurationView;
